import { render, staticRenderFns } from "./AssingBox.vue?vue&type=template&id=ff428320&"
import script from "./AssingBox.vue?vue&type=script&lang=js&"
export * from "./AssingBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports